import Api from './Api';

class LogicBaseCollectionApi extends Api {
  url = 'logicbasecollections';
}

const singleton = new LogicBaseCollectionApi();
export default singleton;
